/* import __COLOCATED_TEMPLATE__ from './reassign-messages.hbs'; */
/* RESPONSIBLE TEAM: team-proactive-support */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
/* eslint-disable ember/no-actions-hash */
/* eslint-disable ember/no-classic-classes */
import { action } from '@ember/object';
import { alias, readOnly } from '@ember/object/computed';
import { inject as service } from '@ember/service';
import { task } from 'ember-concurrency';
// eslint-disable-next-line ember/no-classic-components
import Component from '@ember/component';
import { UNASSIGNED_ADMIN_ID } from 'embercom/models/admin';

export default Component.extend({
  tagName: '',
  init() {
    this._super(...arguments);
    this.set('reassignments', { conversations: UNASSIGNED_ADMIN_ID, teams: {} });
  },
  appService: service(),
  // eslint-disable-next-line @intercom/intercom/no-legacy-modal
  modalService: service(),
  permissionsMutatorService: service(),
  app: alias('appService.app'),
  isDeleting: readOnly('options.isDeleting'),
  permissionToEdit: alias('model.currentAppPermissions'),
  canSave: readOnly('isValid'),
  isValid: false,
  save: task(function* () {
    try {
      yield this.permissionsMutatorService.savePermission(
        this.model,
        this.permissionToEdit,
        false,
        this.options.removedSeatPriceInfo,
      );
      this.closeModal();
    } catch (e) {
      // noop
    }
  }).drop(),
  closeModal: action(function () {
    if (this.permissionToEdit !== undefined && !this.permissionToEdit.isSaving) {
      // Reset reassign properties if not saving
      this.permissionToEdit.setProperties({
        reassign_replies_admin_id: null,
        reassign_auto_messages_admin_id: null,
        reassign_replies_teams: [],
        reassign_articles_author_id: null,
      });
    }
    this.set('isValid', false);
    this.modalService.closeModal();
  }),

  actions: {
    updateSelection(isValid) {
      this.permissionToEdit.reassignments = this.reassignments;
      this.set('isValid', isValid);
    },
  },
});
